import React from 'react'
//import { StaticImage } from "gatsby-plugin-image"

import amerex_logo from '../images/meci-amerex-logo-plain.svg'
// import amerex_logo from '../images/amerex_mex_logo_neg.svg'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFacebookSquare,
  faWhatsappSquare,
  // faTwitterSquare,
  // faInstagramSquare,
} from '@fortawesome/free-brands-svg-icons'

const Navbar = () => (
  <div>
    {/* top bar */}
    <div className='d-flex justify-content-end align-items-center px-4 py-2 text-light bg-dark'>
      <div className='d-flex align-items-center m-0 p-0'>
        <p className='p-0 m-0'>
          Conmutador: (81) 1534-9214 |{' '}
          <span>
            <a className='text-white' href='mailto:ventas@mercantil.mx'>
              ventas@mercantil.mx
            </a>
          </span>
        </p>
        <a
          className='icon-link'
          href='https://www.facebook.com/amerexmexico'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Visitar página de Amerex en Facebook'
        >
          <FontAwesomeIcon className='fa-2x mx-1' icon={faFacebookSquare} />
        </a>
        <a
          className='icon-link'
          href='https://wa.me/message/M55IVMFYJGL4A1'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Solicitar información por WhatsApp'
        >
          <FontAwesomeIcon className='fa-2x mx-1' icon={faWhatsappSquare} />
        </a>
      </div>
    </div>
    {/* navbar */}
    <nav className='navbar navbar-expand-md bg-red-amerex'>
      <div className='container-fluid align-items-md-stretch'>
        <Link className='navbar-brand' to='/'>
          <img src={amerex_logo} alt='Amerex logo' width='200px' />
        </Link>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarCollapse'
          aria-controls='navbarCollapse'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>
        <div
          className='collapse navbar-collapse justify-content-end align-items-md-stretch'
          id='navbarCollapse'
        >
          <ul className='navbar-nav w-100 justify-content-around align-items-center'>
            {/* <li class="nav-item dropdown">
              <Link
                class="nav-link dropdown-toggle"
                to="#"
                id="extinguidores"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                EXTINGUIDORES
              </Link>
              <ul class="dropdown-menu" aria-labelledby="extinguidores">
                <li>
                  <Link class="dropdown-item" to="/portatiles">
                    PORTÁTILES
                  </Link>
                </li>
                <li>
                  <Link class="dropdown-item" to="/unidades-moviles">
                    UNIDADES MÓVILES
                  </Link>
                </li>
              </ul>
            </li> */}
            <li className='nav-item'>
              <Link className='nav-link' to='/portatiles'>
                EXTINTORES PORTÁTILES
              </Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/unidades-moviles'>
                UNIDADES MÓVILES
              </Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/sistemas-incendio'>
                SISTEMAS CONTRA INCENDIO
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
)

export default Navbar
